import { connect } from 'react-redux';
// @flow
import { compose } from 'recompose';

import Stores from './Stores';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Stores);
